module.exports = __webpack_public_path__ + "static/media/panda driving a motor-bike.db00ab2c.jpeg";